import { PRIMARY_ICON_BY_ID } from './icons';

type PrimaryIconProps = {
  id: string;
  size?: number;
  className?: string;
  'aria-hidden'?: boolean;
};

export function PrimaryIcon({ id, size = 20, className, ...rest }: PrimaryIconProps) {
  const inner = PRIMARY_ICON_BY_ID[id];
  if (!inner) return null;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...rest}
      dangerouslySetInnerHTML={{ __html: inner }}
    />
  );
}
